import { Form } from 'antd';
import cashierApis from 'modules/POS/services/apis';
import {
  forwardRef,
  startTransition,
  useImperativeHandle,
  useRef,
  useState,
} from 'react';
import { IResponseData } from 'services/response';
import HeaderActionButton, {
  HeaderActionButtonType,
} from '../../HeaderActions/HeaderActionButton';
import { cashierCtrl } from '../../cashier.controller';
import { IUISelectItem } from '../../cashier.interface';
import CashierActionButton, {
  ActionType,
} from '../../components/CashierActionButton';
import ModalSelfGift from './ModalSelfGift';
import { IssueFormValues } from './ModalSelfGift/IssueGiftCard';
enum GIFT_CARD_RADIO_TYPE {
  ISSUED = 'ISSUED',
  BALANCE = 'BALANCE',
}
export type IGiftCardResult = {
  code: string;
  amount: number;
  expireDate: string;
};
type Props = {
  add: (item: IUISelectItem) => void;
  header?: boolean;
};
type Ref = {
  open: () => void;
};
export const useCashierSellGift = () => useRef<Ref>(null);
const CashierSellGift = forwardRef<Ref, Props>(
  ({ header }, ref) => {
    const [form] = Form.useForm();
    const [formCheck] = Form.useForm();
    const [visible, setVisible] = useState(false);
    const [radioType, setRadioType] = useState<GIFT_CARD_RADIO_TYPE>(
      GIFT_CARD_RADIO_TYPE.ISSUED
    );
    const handleOpen = () => {
      setVisible(true);
    };
    const reset = () => {
      setRadioType(GIFT_CARD_RADIO_TYPE.ISSUED);
      form.resetFields();
    };
    const handleClose = () =>
      startTransition(() => {
        setVisible(false);
        reset();
      });

    const isNotExist = async (code: string) => {
      if (code?.length < 4) return;
      try {
        const res: IResponseData<any> = await cashierApis.getGiftCardInfo(code);
        if (res.data.data) {
          return false;
        }
        return true;
      } catch (error) {
        return true;
      }
    };
    const handleCheckExistGiftCard = async (code: string) => {
      // setLoading(true);
      await isNotExist(code);
      // setLoading(false);
    };

    const onFinishAfterPassValid = async (values: IssueFormValues) => {
      cashierCtrl.saleGiftCard(values);
      handleClose();
    };

    useImperativeHandle(ref, () => ({
      open: handleOpen,
    }));

    return (
      <>
        {header ? (
          <HeaderActionButton
            type={HeaderActionButtonType.SELL_GIFT}
            onClick={handleOpen}
          />
        ) : (
          <CashierActionButton
            type={ActionType.SELL_GIFT}
            onClick={handleOpen}
          />
        )}
        <ModalSelfGift
          visible={visible}
          onClose={handleClose}
          radioType={radioType}
          setRadioType={setRadioType}
          checkExistGiftCard={handleCheckExistGiftCard}
          formCheck={formCheck}
          formIssue={form}
          onSubmit={onFinishAfterPassValid}
        />
      </>
    );
  }
);
CashierSellGift.displayName = 'CashierSellGift';
export default CashierSellGift;
